import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { Employee } from "../../Objects/Employee/Employee"
import { GetRequest } from "../../services/ApiClientService"
import { employeeMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useTranslation } from "react-i18next"

export const useGetEmployee = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetEmployee = async (onSuccess: any) => {
    enableLoad()
    try {
      const response = await GetRequest<Employee[]>(API_ROUTES.EMPLOYEE.GET_ALL)

      if (response.success) {
        const temp = response.data?.map((ss) => new Employee(ss)) ?? []

        employeeMemory.setList(temp)

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetEmployee,
  }
}
